<div fxLayout="column" fxLayoutGap="20px">
  <div *ngIf="envelope">
    <mat-card class="envelope">
      <div class="info-header-subtitle">
        <div><strong>Envelope nº:</strong> {{ envelope.id }}</div>
        <div><strong>Enviado por:</strong> {{ envelope.enviadoPor }}</div>
        <div><strong>Data de envio:</strong> {{ envelope.dataEnvio | date : 'dd/MM/yyyy HH:mm' }}</div>
      </div>
    </mat-card>
  </div>

  <div *ngIf="!envelope" class="painel-header">
    <div class="header-content">
      <div class="header-text">
        <h2>{{ getDescricaoTipoProva() }}</h2>
        <p class="mat-body-1">Atribua notas aos candidatos e deposite o envelope ao finalizar.</p>
      </div>
      <button mat-flat-button color="primary" class="btn-instrucoes" (click)="toggleInstrucoes()">
        <mat-icon>{{ instrucoesExpandidas ? 'close' : 'help_outline' }}</mat-icon>
        {{ instrucoesExpandidas ? 'Fechar' : 'Instruções' }}
      </button>
    </div>
  </div>

  <mat-card *ngIf="instrucoesExpandidas && !envelope" class="card-instrucoes" [@slideDown]>
    <mat-card-content class="instrucoes-content">
      <div class="secao-instrucoes">
        <h3><mat-icon>info</mat-icon>Dicas para o preenchimento das notas</h3>
        <ul>
          <li>A nota é atribuída na visualização dos documentos</li>
          <li>Atribuir nota em números decimais de <strong>0 (zero) a 10 (dez)</strong>.</li>
          <li>Utilize até <strong>duas casas decimais</strong> (ex.: 7,50 ou 8,75).</li>
          <li>Ao finalizar a atribuição de todas as notas e revisar, clique no final dessa página no botão <strong>"Depositar envelope com notas atribuídas e revisadas"</strong>. Esta ação é obrigatória, e após isso as notas não poderão ser alteradas.</li>
          <li>Certifique-se de revisar todas as notas antes de depositar seu envelope. A correção das demais provas da fase depende desta ação.</li>
          <li>Use <strong>Ctrl + F</strong> para localizar rapidamente um candidato na tabela.</li>
        </ul>
      </div>
    </mat-card-content>
  </mat-card>

  <div *ngIf="envelope" class="title">
    <span>{{ getDescricaoTipoProva() }}</span>
  </div>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="inscricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inscricao</th>
        <td mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome Social / Nome</th>
        <td mat-cell *matCellDef="let row">
          <strong>{{ row.nomeSocial || row.nome }}</strong
          ><br />
          <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="nomeSocial">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome Social</th>
        <td mat-cell *matCellDef="let row">{{ row.nomeSocial }}</td>
      </ng-container>

      <ng-container matColumnDef="nota">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nota</th>
        <td mat-cell *matCellDef="let row">
          <!-- TODO: Mudar esse input pra mostrar o valor da nota só -->
          <span class="score-text">
            {{ row.nota }}
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="tipoProva === 'ESCRITA'" matColumnDef="nomeDocumentoProva">
        <th mat-header-cell *matHeaderCellDef>Prova</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.arquivoProva; else semProva">
            <button
              mat-icon-button
              color="primary"
              (click)="visualizarDocumento(row.inscricaoId, row.idArquivoProva, row.arquivoProva)"
              matTooltip="Visualizar prova">
              <mat-icon>visibility</mat-icon>
            </button>
            <button *ngIf="getReportePorDocumentoId(row.idArquivoProva)" mat-icon-button
              (click)="abrirHistoricoReporte(row.idArquivoProva)"
              [matTooltip]="'Reporte de identificação: ' + getReportePorDocumentoId(row.idArquivoProva)?.status"
              class="reporte-indicator">
              <mat-icon [color]="getReporteStatusClass(row.idArquivoProva)" [style]="getReporteIconStyle(row.idArquivoProva)">warning</mat-icon>
            </button>
          </span>
          <ng-template #semProva>
            <span
              class="text-error"
              matTooltip="Upload da prova não realizado, entrar em contato com administrador do concurso!"
              >Sem arquivo</span
            >
          </ng-template>
        </td>
      </ng-container>
      <ng-container *ngIf="tipoProva !== 'ESCRITA'" matColumnDef="documentos">
        <th mat-header-cell *matHeaderCellDef>Documentos</th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            color="primary"
            (click)="visualizarDocumentosComplementares(row.inscricaoId, row.nota)"
            matTooltip="Visualizar documentos complementares">
            <mat-icon>folder</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
    </table>
  </div>

  <div class="text-center-mt-20" *ngIf="!envelope">
    <div *ngIf="envelopeBloqueado" class="card-info card-icon" style="margin-bottom: 16px;">
      <mat-icon>lock</mat-icon>
      <span>Envelope bloqueado: existe reporte de identificação pendente de decisão do presidente.</span>
    </div>
    <button mat-raised-button color="primary" (click)="incluirNoEnvelope()" [disabled]="!todasNotasPreenchidas() || envelopeBloqueado" [class.pulse-animation]="todasNotasPreenchidas() && !envelopeBloqueado">
      Depositar envelope com notas atribuídas e revisadas
    </button>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center" class="mt-20">
    <button mat-raised-button color="primary" (click)="voltar()" matTooltip="Voltar para a listagem de provas">
      <mat-icon>arrow_back</mat-icon>
      Voltar
    </button>
  </div>
</div>
